import React from "react";
import { Col, Container, Row } from "reactstrap";
import CountUp from "react-countup";
import { Link } from "react-router-dom";
import HomeUrl from "../assets/images/home-border.png";

const Services = () => {
  const services = [
    {
      id: "service1",
      icon: "mdi-web",
      title: "Web Development",
      description:
        "We craft responsive and high-performance websites tailored to enhance your online presence and meet your business objectives.",
    },
    {
      id: "service2",
      icon: "mdi-cellphone-android",
      title: "App Development",
      description:
        "Our team develops intuitive mobile applications to help your business reach a wider audience on both Android and iOS platforms.",
    },
    {
      id: "service3",
      icon: "mdi-chart-line",
      title: "Digital Marketing",
      description:
        "We offer digital marketing services, including SEO and social media management, to boost your brand's visibility and engagement.",
    },
    {
      id: "service4",
      icon: "mdi-cash-multiple",
      title: "SE Arbitrage",
      description:
        "Our search engine arbitrage strategies focus on low-cost, high-value keyword targeting to maximize your ROI on ad spend.",
    },
  ];

  const counters = [
    {
      id: "1",
      extraclass: "",
      start: 0,
      end: 4,
      title: "Core Services",
      description:
        "Offering a focused range of services to meet your digital needs.",
    },
    {
      id: "2",
      extraclass: "pt-3",
      start: 0,
      end: 100,
      title: "Commitment Level",
      description:
        "Dedicated to delivering exceptional results and client satisfaction.",
    },
    {
      id: "3",
      extraclass: "pt-3",
      start: 0,
      end: 24,
      title: "Support Hours",
      description:
        "Providing support around the clock to ensure your success.",
    },
  ];

  return (
    <section className="section bg-services" id="services">
      <Container>
        <Row>
          <Col lg="12">
            <div className="title-box text-center">
              <h3 className="title-heading mt-4">Our Services</h3>
              <p className="text-muted f-17 mt-3">
                At Webora, we provide innovative IT and digital marketing solutions designed to grow your business and enhance your online presence.
              </p>
              <img src={HomeUrl} height="15" className="mt-3" alt="Decoration" />
            </div>
          </Col>
        </Row>
        <Row className="mt-5 pt-4">
          {services.map(({ id, icon, title, description }) => (
            <Col lg={3} md={6} key={id}>
              <div className="services-box p-4 mt-4">
                <div className="services-icon bg-soft-primary">
                  <i className={`mdi text-primary ${icon}`}></i>
                </div>
                <h5 className="mt-4">{title}</h5>
                <p className="text-muted mt-3">{description}</p>
              </div>
            </Col>
          ))}
        </Row>
        <Row className="align-items-center mt-5 pt-4" id="counter">
          <Col lg={6}>
            <div className="pr-4 mt-4">
              <p className="text-uppercase">Why Choose Webora</p>
              <h3>Partner with Us for Your IT Success</h3>
              <p className="text-muted mt-3">
                At Webora, we are committed to delivering customized solutions that drive results. Our focus on innovation and quality ensures that your business is empowered to thrive in the digital landscape.
              </p>
              <div className="mt-4 pt-1">
                <Link to="#" className="btn btn-outline-primary">
                  Discover More
                </Link>
              </div>
            </div>
          </Col>
          <Col lg={5} className="offset-lg-1">
            <div className="counter-box">
              {counters.map(({ id, extraclass, start, end, title, description }) => (
                <div className={extraclass} key={id}>
                  <div className="media">
                    <div className="count-box bg-soft-primary text-center">
                      <h3 className="counter-count mb-1 text-primary">
                        <CountUp className="counter-value" delay={2} start={start} end={end} />{" "}
                        <span className="count-plus text-primary">+</span>
                      </h3>
                      <p className="text-uppercase text-muted mb-0 f-14">{title}</p>
                    </div>
                    <div className="media-body pl-4">
                      <p className="text-muted mb-0 mt-3">{description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Services;
